import { apiInstance } from "../config/apiInstance";
import { AUDITOR_SIGNATURE } from "../index";
import { AuditorSignatureResponse } from "shared/models";
import Swal from "sweetalert2";

export const getAuditorSignature = async (): Promise<AuditorSignatureResponse | null> => {
  try {
    const response = await apiInstance.get<AuditorSignatureResponse>(AUDITOR_SIGNATURE);
    return response.data;
  } catch (e: any) {
    // If user doesn't have signature, return null instead of showing error
    if (e?.response?.status === 404) {
      return null;
    }
    Swal.fire({
      title: "Error al obtener firma",
      text: e?.response?.data?.message || e.message || "No se pudo obtener la información de la firma",
      icon: "error",
      timer: 4000,
    });
    return null;
  }
};
